const EncryptionHelper = () => {


    const encryptBase64 = (str: string): string => {
        return str ? btoa(unescape(encodeURIComponent(str))) : ''
    }

    const decryptBase64 = (str: string): string => {
        return str && str.length > 0 ? decodeURIComponent(escape(atob(str))) : '';
    }

    return {
        encryptBase64,
        decryptBase64
    };
}
export default EncryptionHelper();
